<template>
  <div class="table-support">
    <v-simple-table class="px-5 pb-5"
                    height="700px">
      <thead>
      <tr>
        <th class="text-left" style="max-width: 150px; min-width: 150px">Mã khách hàng</th>
        <th class="text-left" style="max-width: 120px; min-width: 120px">Mã học sinh</th>
        <th class="text-left" style="max-width: 150px; min-width: 150px">Tên học sinh</th>
        <th class="text-left" style="max-width: 100px; min-width: 100px">Ngày tạo</th>
        <th class="text-left" style="max-width: 150px; min-width: 150px">Nhóm ticket</th>
        <th class="text-left" style="max-width: 150px; min-width: 150px">Loại ticket</th>
        <th class="th_status" style="max-width: 140px; min-width: 140px">Độ ưu tiên</th>
        <th class="th_status text-center" style="max-width: 140px; min-width: 140px">Người tạo</th>
        <th class="text-center" style="max-width: 150px; min-width: 150px">Người xử lý</th>
        <th class="text-left" style="max-width: 150px; min-width: 150px">Trạng thái xử lý</th>
        <th class="text-left" style="max-width: 100px; min-width: 100px">Kết quả</th>
        <th class="text-left content" style="max-width: 350px; min-width: 350px">Mô tả</th>
        <th class="text-left content" style="max-width: 350px; min-width: 350px">Nội dung xử lý</th>
      </tr>
      </thead>
      <tbody v-for="(item, index) in requestList" :key="index">
      <tr @click="handleViewDetail(item)">
        <td>{{_.get(item, 'customFields.customerCode', '')}}</td>
        <td class="text-left">
          {{ item.customFields ? item.customFields.studentId : "_" }}
        </td>
        <td class="text-left">
          {{item.customFields ? item.customFields.studentName : "_"}}
        </td>
        <td class="text-left">
          {{ formatDate(item.createdAt) || "_" }}
        </td>
        <td class="text-left">{{ item.template ? item.template.groupTicketName : "_" }}</td>
        <td class="text-left">{{ item.template ? item.template.typeTicketName : "_" }}</td>
        <td class="text-left">
          <div v-if="item.priority" class="d-flex align-center justify-center">
            <div :style="`background: ${renderPriority(item.priority.id).color}`" class="priority-dot mr-2"></div>
<!--            <v-icon style="font-size: 32px" v-if="renderPriority(item.priority).color" :color="renderPriority(item.priority).color">mdi-circle-small</v-icon>-->
            {{ renderPriority(item.priority.id).name}}
          </div>
          <div v-else class="d-flex justify-center">
            _
          </div>
        </td>
        <td class="text-center">{{ item.createdBy.username || "_" }}</td>
        <td class="text-center">{{ item.handler || "_" }}</td>
        <td class="text-left">
          <div
            class="ticket-status-box"
            v-if="item.status"
            :style="`background: ${listTicketStatus.some((e) => e.value === item.status.name) ? listTicketStatus.find((e) => e.value === item.status.name).color : '#000000'}`"
            style="color: white">
            {{ item.status.name}}
          </div>
          <div v-else>
            _
          </div>
        </td>
        <td class="text-left">{{ item.result || "_" }}</td>
        <td class="text-left">{{ item.customFields.description || "_" }}</td>
        <td class="text-left">{{ item.resultDetail || "_" }}</td>
      </tr>
      </tbody>
      <tbody v-if="requestList.length <= 0">
      <tr>
        <td colspan="100">
          <common-no-result />
        </td>
      </tr>
      </tbody>
    </v-simple-table>

    <div class="pb-3">
      <!--            <v-pagination-->
      <!--                v-if="totalItem > limit"-->
      <!--                v-model="currentPage"-->
      <!--                class="justify-sm-end"-->
      <!--                :length="getTotalItem(totalItem)"-->
      <!--                prev-icon="mdi-menu-left"-->
      <!--                next-icon="mdi-menu-right"-->
      <!--            />-->

      <v-col
        cols="12"
        md="12"
        class="pb-0"
        style="display: flex; justify-content: flex-end; padding: 0 12px"
      >
        <div class="text-right mb-1 mt-2">
          {{ showIndex() }}
          <v-btn
            small
            class="pagination-btn-left"
            @click="
              () => {
                currentPage--;
              }
            "
            :disabled="currentPage == 1"
          >
            <v-icon>mdi-menu-left</v-icon>
          </v-btn>
          <v-btn
            :disabled="(requestList.length < limit || currentPage * limit >= totalItem)"
            small
            class="pagination-btn-right"
            @click="
              () => {
                currentPage++;
              }
            "
          >
            <v-icon>mdi-menu-right</v-icon>
          </v-btn>
        </div>
      </v-col>
    </div>
    <TicketDetailPopup @close="isShowTicketDetail = false" :item="selectedTicket" :is-show-ticket-detail="isShowTicketDetail"></TicketDetailPopup>
  </div>
</template>

<script>
import moment from 'moment';
import SupportRepository from '@/services/SupportRepository';
import { PRIORITY_SUPPORT, LIST_STATUS_SUPPORT } from '@/modules/ticket/const';
import TicketDetailPopup from '@/modules/ticket/components/TicketDetailPopup.vue';
import TokenService from '@/helpers/token';
import { mapState } from 'vuex';

export default {
  components: {
    TicketDetailPopup,
  },
  data() {
    return {
      isShowTicketDetail: false,
      selectedTicket: {},
      currentPage: 1,
      requestList: [],
      statusList: [],
      totalItem: 0,
      limit: 20,
      filterForm: {
        dateRange: [],
      },
      file: {},
      stringBase64: '',
      requestSelected: {},
      PRIORITY_SUPPORT,
      LIST_STATUS_SUPPORT,
    };
  },
  computed: {
    ...mapState('ticket', ['listTicketStatus']),
  },
  async created() {
    if (this.$route.query?.createdAt) {
      this.filterForm.activatedAt = [moment(this.$route.query?.createdAt).format('YYYY-MM-DD'), moment(this.$route.query?.createdAt).format('YYYY-MM-DD')];
    }
    if (this.$route.query.ticketId) {
      await this.getTicketDetail(this.$route.query.ticketId);
    } else {
      this.filterForm.createdName = this.$route.query?.createdName;
      this.filterForm.customerCode = this.$route.query?.nameCode;
      await this.getListSupportV2(this.filterForm);
    }
    Bus.$on('search-request-support-list-2', (filterForm) => {
      this.filterForm = filterForm;
      this.currentPage = 1;
      this.getListSupportV2(this.filterForm);
    });
    Bus.$on('fetch-table-while-change-tab5', () => {
      this.getListSupportV2(this.filterForm);
    });
  },
  beforeDestroy() {
    Bus.$off('search-request-support-list-2');
    Bus.$off('fetch-table-while-change-tab5');
  },
  watch: {
    currentPage: {
      handler() {
        this.getListSupportV2(this.filterForm);
      },
    },
  },
  methods: {
    async getTicketDetail(id) {
      const loading = this.$loading.show();
      const response = await SupportRepository.getTicketDetail(id);
      if (response.message === 'Success') {
        this.requestList = [response.data];
      }
      loading.hide();
    },
    handleViewDetail(item) {
      this.selectedTicket = item;
      this.isShowTicketDetail = true;
    },
    renderPriority(value) {
      const priority = _.find(this.PRIORITY_SUPPORT, { value });
      return priority || '_';
    },
    async getListSupportV2(param) {
      const query = {};
      this.$router.replace({ query });
      const loading = this.$loading.show();
      const user = TokenService.getUser();
      const params = {
        ...param,
        systemId: 3,
        startDate: param.dateRange[0],
        endDate: param.dateRange[1],
        nameCode: param.viewType ? param.nameCode : user.username,
        limit: 20,
        page: this.currentPage,
      };
      delete params.dateRange;
      const res = await SupportRepository.getListSupportsV2(params);
      if (res.success) {
        this.requestList = _.get(res, 'data', []);
        this.totalItem = _.get(res, 'totalItem', 0);
      } else {
        this.requestList = [];
      }
      loading.hide();
    },
    formatDate(date) {
      if (date) {
        return moment(date).format('HH:mm:ss DD/MM/YYYY');
      }
      return '';
    },
    showIndex() {
      if (this.requestList.length > 0) {
        // eslint-disable-next-line radix
        const maxIndex = this.requestList.length < this.limit ? parseInt(this.currentPage - 1) * parseInt(this.limit) + this.requestList.length : parseInt(this.currentPage) * parseInt(this.limit);
        // eslint-disable-next-line radix
        return this.requestList.length < this.limit ? `${maxIndex - parseInt(this.requestList.length) + 1} - ${maxIndex}` : `${maxIndex - parseInt(this.limit) + 1} - ${maxIndex}`;
      }
      return ('0 - 0');
    },
  },
};
</script>

<style scoped>
.priority-dot {
  background: #000;
  border-radius: 50%;
  height: 10px;
  width: 10px;
}
.ticket-status-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 5px;
  width: fit-content;
}
/deep/table tr th {
  text-align: center !important;
  border-bottom: 1px solid #8e8e8e !important;
  height: 30px;
  font-weight: 900 !important;
  padding: 20px 0;
  color: #777777 !important;
  font-size: 14px !important;
  padding: 15px !important;
  position: sticky;
  top: 0;
  background-color: #fff !important;
}

/deep/table tr th.content {
  width: 300px;
  text-wrap: wrap;
}
/deep/table tr th.time {
  width: 100px;
  text-wrap: wrap;
}

/deep/table tr td {
  border-bottom: 1px solid #8e8e8e !important;
  height: 35px !important;
  padding: 15px !important;
  font-weight: 500 !important;
  color: #777777 !important;
  font-size: 12px !important;
}

.th_mobile {
  width: 110px;
}

.th_status {
  width: 130px;
}

.td_request {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 250px;
}

.td_urgent {
  max-width: 150px !important;
  min-width: 100px !important;
}
.file-icon {
  transform: rotate(-45deg);
}
.pagination-btn-left, .pagination-btn-right {
  max-width: 30px !important;
  min-width: 30px !important;
  background-color: #ffffff !important;
}

.pagination-btn-left i, .pagination-btn-right i {
  color: rgba(0,0,0,.54) !important
}

.pagination-btn-left {
  margin: 0px 5px 2px 10px !important;
}

.pagination-btn-right {
  margin: 0px 10px 2px 5px !important;
}
</style>
